module.exports = __webpack_public_path__ + "media/images/redrock/backdrop-94ead45ab413b76ec4ed27d78e08d7f1.jpeg";